import { ReactNode } from "react";
import { LoadingSpinner } from "@components/LoadingSpinner";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const LoadingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex-grow: 1;
`;

export const Loader = ({
  children,
  isLoading,
  align = "center"
}: {
  children: ReactNode;
  isLoading: boolean;
  align?: "flex-end" | "center";
}) => {
  return isLoading ? (
    <LoadingContainer className="loader" style={{ alignItems: align }}>
      <LoadingSpinner />
    </LoadingContainer>
  ) : (
    children
  );
};
